import { useAuthState } from "react-firebase-hooks/auth";
import {adminEmail} from "./index.tsx";
import { useNavigate } from 'react-router-dom';
import { logoutUtente, auth, realtimeDb, verifyPasswordBeforeDelete, deleteEmailPasswordAccount, deleteGoogleAccount, salvaStatisticheUtilizzo }  from './FirestoreDataLoader.tsx';
import React, {useState} from 'react';
import { Eye, EyeOff } from "lucide-react";
import { useConfirmToast } from "./alertFunction.tsx";
import { onAuthStateChanged } from "firebase/auth";
import { ref as databaseRef, update } from "firebase/database";


type ShowLogoutProps = {
  setShowLogoutModal: React.Dispatch<React.SetStateAction<boolean>>;
  classNameButton: string;
};

export const name = auth.currentUser?.email

//logout
export const ShowLogout: React.FC<ShowLogoutProps> = ({ setShowLogoutModal, classNameButton }) => {

  const { errorAlert, successAlert } = useConfirmToast();

  //const [user] = useAuthState(auth);
  //const navigate = useNavigate();
  const [showModaleCA, setShowModaleCA] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const handleOut = async() => {
    if (!auth || !realtimeDb) return;
    const unsubAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const databaseRefForPresence = databaseRef(realtimeDb, `presenza/${user.uid}`);
        update(databaseRefForPresence, {ultimoAccessoTimestamp: new Date().toISOString()});     
      }
    });     
    const success = await logoutUtente();
    if (success){
      successAlert("", "Logout Effettuato!")
    };
    return () => unsubAuth();
  }

  const handleDeleteWP = async (password: string) => {
    try {
      const isValid = await verifyPasswordBeforeDelete(password);
      if (!isValid) return;

      const deleted = await deleteEmailPasswordAccount(); 
      if (deleted) {
        await successAlert("", "Account eliminalto!")
        window.location.assign('/bye')//navigate('/bye');
      } else {
        errorAlert("Errore durante l'eliminazione dell'account.");
      }
    } catch (error) {
      errorAlert("Password errata. Riprova.<br/>Se ti sei registrato con Google, clicca l'apposito link.");
      console.error(error);
    }
  };

  const handleDeleteG = async () => {
    try {
      const deleted = await deleteGoogleAccount(); 
      if (deleted) {
        await successAlert("", "Account eliminalto!")
        window.location.assign('/bye')//navigate('/bye');
      } else {
        errorAlert("","Errore durante l'eliminazione dell'account.");
      }
    } catch (error:any) {
      errorAlert(`${error.code}`, "Si è verificato un errore inatteso.");
      console.error(error);
    }
  };  


  // Mostra modale di cancellazione account
  if (showModaleCA) {
    return (
      <div className='modal-overlay'>
        <div className='modal-content OUT' style={{maxWidth:'40%'}}>
          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button onClick={() => {setShowModaleCA(false), setShowLogoutModal(false)}} className="Xclose">✕</button>
          </div>
          <div style={{padding:'0 4rem 4rem 4rem'}}>
            <label >
              <p style={{ fontSize: "20px", fontFamily: "Segoe UI", fontWeight: "500", paddingBottom:"1rem"  }}>
                🚨 In questa scheda puoi cancellare il tuo account.
              </p>  
              <p style={{ fontSize: "16px", fontFamily: "Segoe UI", fontWeight: "500", backgroundColor: "#ca1818", color:"#ffffff", paddingLeft:"1rem", paddingRight:"1rem", paddingTop:"0.5rem",marginTop:"0.5rem" }}>
               ⚠️ La cancellazione del tuo account è definitiva e irreversibile. ⚠️
              </p>
              <p style={{ fontSize: "16px", fontFamily: "Segoe UI", fontWeight: "500", backgroundColor: "#ca1818", color:"#ffffff", paddingLeft:"1rem", paddingRight:"1rem", paddingBottom:"0.5rem" }}>
                Tutti i tuoi dati e contenuti associati all'account verranno eliminati in modo permanente e non sarà possibile recuperarli.
              </p>
              <p style={{ fontSize: "16px", fontFamily: "Segoe UI", fontWeight: "400", paddingLeft:"1rem", paddingTop:"1rem" }}>
                Se sei sicuro di voler procedere, inserisci la tua password e clicca su "Cancella il mio account".
              </p>
            </label>
            <div style={{display:"grid", gridTemplateColumns:"35% 30% 35%", justifyItems:"center"}}>
              <div className="pass-cell" style={{marginTop:"2.5rem", gridColumn:2}}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input Pass"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <div
                  onClick={() => setShowPassword(!showPassword)}
                  className="eye-EyeOff"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </div>
              </div>
              <button onClick={() => handleDeleteWP(password)} className={classNameButton} style={{ gridColumn:"2", marginTop:"1rem", maxHeight:"2.5rem", width:"13rem"}}>Cancella il mio account</button>    
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "3rem" }}>
              <button onClick={handleDeleteG} style={{ border: "0", backgroundColor: "white", fontSize: "14px", fontFamily: "Segoe UI", userSelect: "none", cursor: "default", maxWidth: "fit-content" }}>
                Se ti sei registrato tramite Google <span className="fakeLink">clicca qui</span> per cancellare il tuo account.
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Modale di logout
  return (
    <div className='modal-overlay'>
      <div className='modal-content OUT'>
        <div style={{display:'flex', justifyContent:'flex-end'}}>
          <button onClick={() => setShowLogoutModal(false)} className="Xclose">✕</button>
        </div>
        <div className='label-button' style={{borderBottom:'1px solid #ccc', margin:'0 2rem 1rem 2rem'}}>
          <div style={{marginBottom: "1.5rem", fontWeight: 600, fontFamily:'Segoe UI', }}>
            <p>Stai per effettuare il Logout.<br />Sei sicuro di voler uscire?</p>
          </div>
          <button onClick={async() => {handleOut()}} className={`${classNameButton}X`} style={{ backgroundColor:'#cf3a3aff', maxWidth: "7rem", marginBottom: "0.5rem", maxHeight: "2.5rem", fontSize: "14px" }}>Esci</button>
          <button onClick={() => setShowLogoutModal(false)} className={classNameButton} style={{ maxWidth: "7rem", marginBottom: "0.5rem", maxHeight: "2.5rem", fontSize: "14px" }}>Indietro</button>
          <br />
        </div>
        <button onClick={() => setShowModaleCA(true)} className="cancellAccount" style={{ border: "0", paddingBottom:'1rem', backgroundColor: "white", fontSize: "12px", fontFamily: "Segoe UI", margin: "0 0 2rem 2rem", userSelect: "none", maxHeight: "1rem", textAlign:"left" }}>
          Cancella Account 🛈
        </button>
      </div>
    </div>
  );
};